
































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Inquiry from '../../../api/v2/models/inquiry'
import api from '../../../api/v2/api'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import UserInquiryDialog from '../organisms/UserInquiryDialog.vue'
import InquiryView from '../atoms_molecules/InquiryView.vue'
import { ROUTER_NAME } from '../../router'
import ConfirmDialog from '../atoms_molecules/ConfirmDialog.vue'

@Component({
  components: { 
    UserInquiryDialog,
    InquiryView,
    ConfirmDialog,
  }
})
export default class InquiryList extends Vue {
  inquiries: Inquiry[] = []
  $refs: {
    confirm: ConfirmDialog
  }

  breadcrumbs = [
    {
      text: 'クラスルーム',
      disabled: false,
      exact: true,
      to: '/classroom/'
    },
    {
      text: '問い合わせ一覧',
      disabled: false,
      exact: true,
      to: '/classroom/inquiries'
    }
  ]

  created() {
    headerState.setTitle('問い合わせ')
    footerState.setFooterDefault()
    this.getList();
  }

  async getList() {
    this.inquiries = await api.inquiry.index()
  }

  toDetail(inquiry: Inquiry) {
    this.$router.push({
      name: ROUTER_NAME.INQUIRY_DETAIL,
      params: {
        inquiryId: inquiry.id.toString()
      }
    })
  }

  async deleteInquiry(id: number) {
    try {
      if (await (this.$refs.confirm as any).open('本当によろしいですか？')) {
        await api.inquiry.delete(id)
        this.getList()
      }
    } catch(e) {
    } finally {
    }
  }

}
